import { render, staticRenderFns } from "./WebToppings.vue?vue&type=template&id=dd4bb55a&scoped=true&"
import script from "./WebToppings.vue?vue&type=script&lang=js&"
export * from "./WebToppings.vue?vue&type=script&lang=js&"
import style0 from "./WebToppings.vue?vue&type=style&index=0&id=dd4bb55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4bb55a",
  null
  
)

export default component.exports